import { version } from '../../../../../package.json';

/**
 * The shell's own version, straight from the workspace `package.json` at build
 * time — the number support asks for first. One source: bumping the package
 * version is the release step, and every screen that shows a version follows.
 */
export const SHELL_VERSION: string = version;
